module.exports = __webpack_public_path__ + "static/media/info_icon.2ed45958.svg";